import { Theme } from "@mui/material/styles";
import { createStyles, makeStyles } from "@mui/styles";
import { StyleSheet } from "@react-pdf/renderer";

import VoTheme from "ui/theme/vocollege2";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      flex: 1,
      flexDirection: "column",
    },
  })
);

export const styles = StyleSheet.create({
  page: {
    fontFamily: "Arial",
    fontSize: 15,
    padding: VoTheme.spacing(4),
  },
  decor: {
    height: "100%",
    paddingLeft: VoTheme.spacing(3),
    paddingRight: VoTheme.spacing(3),
    width: "100%",
    justifyContent: "space-between",
  },

  header: {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    minHeight: 200,
  },

  growArea: {
    alignItems: "center",
    display: "flex",
    flexDirection: "row",
    flexGrow: 1,
  },

  titleWrapper: {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    width: "100%",
  },

  title: {
    color: VoTheme.palette.primary.main,
    fontSize: 36,
    fontWeight: 600,
    marginTop: VoTheme.spacing(1),
    textAlign: "center",
  },
  subtitle: {
    color: VoTheme.palette.primary.main,
    fontSize: 18,
    fontWeight: 600,
    marginTop: VoTheme.spacing(0.5),
    textAlign: "center",
  },
  logo: {
    height: "100px",
    width: "auto",
  },

  personWrapper: {
    alignItems: "center",
    flexDirection: "column",
    justifyContent: "center",
    marginBottom: VoTheme.spacing(4),
    padding: VoTheme.spacing(2),
  },

  person: {
    fontSize: 24,
    fontStyle: "italic",
    fontWeight: 500,
    textAlign: "center",
  },
  personalNumber: {
    fontSize: 12,
    marginTop: VoTheme.spacing(0.5),
    textAlign: "center",
  },
  text: {
    fontSize: 12,
    paddingTop: VoTheme.spacing(0.5),
    textAlign: "center",
  },
  textBold: {
    fontWeight: 500,
  },
  signatures: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    marginLeft: "auto",
    marginRight: "auto",
    width: "100%",
  },
  signature: {
    borderTop: `1px solid ${VoTheme.palette.common.black}`,
    flex: 1,
    height: "40px",
    marginLeft: VoTheme.spacing(2),
    marginRight: VoTheme.spacing(2),
    maxWidth: 250,
    paddingTop: VoTheme.spacing(1),
  },
  signaturePerson: {
    fontSize: 12,
    textAlign: "center",
  },
  signatureTitle: {
    fontSize: 12,
    textAlign: "center",
  },
  publisherSection: {
    display: "flex",
    flexGrow: 1,
    flexDirection: "column",
    justifyContent: "center",
    marginTop: VoTheme.spacing(2),
  },
  publisher: {
    fontSize: 12,
    textAlign: "center",
  },
  place: {},
  date: {
    fontSize: 12,
    marginTop: VoTheme.spacing(0.5),
    textAlign: "center",
  },
  footer: {
    marginTop: VoTheme.spacing(2),
  },
  uid: {
    position: "absolute",
    right: 0,
    top: 0,
  },
  graphWrapper: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    maxHeight: 300,
  },
  graph: {
    height: 100,
    width: 300,
  },

  stepSectionWrapper: {
    flex: 1,
  },
  stepSection: {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    marginBottom: VoTheme.spacing(1),
    marginLeft: "auto",
    marginRight: "auto",
    maxWidth: 350,
  },
  stepTitle: {
    fontSize: 12,
    fontWeight: 600,
    textAlign: "center",
  },
  stepDescription: {
    fontSize: 10,
    marginTop: VoTheme.spacing(0.5),
    textAlign: "center",
  },
  moduleSection: {
    marginTop: VoTheme.spacing(2),
  },
  moduleDescription: {
    fontSize: 10,
    maxWidth: 350,
    marginLeft: "auto",
    marginRight: "auto",
    paddingTop: VoTheme.spacing(1.5),
    textAlign: "center",
  },
  scopeSection: {
    marginBottom: VoTheme.spacing(1),
  },
});
